<template>
  <div id="app">
    <Menu :token="token" @salir="cerrarSesion"/>

    <div class="contenido-principal">
      <transition name="fade" mode="out-in">
        <router-view class="contenido-principal" @registrarToken="registrarToken"/>
      </transition>
    </div>

    <Pie />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Pie from '@/components/Pie'
import {mapState, mapActions} from 'vuex'
import axios from 'axios'

export default {
  name: 'App',
  created () {
    this.traerParametros()
    this.cargarLocalStorage()
  },
  mounted () {
    this.$router.push('inicio')
  },
  watch: {
      $route(to, from) {
          document.title = to.meta.title || this.titulo;
      },
  },
  data () {
    return {
      
    }
  },
  components: {
    Menu, Pie
  },
  methods: {
    traerParametros() {
        var formData = new FormData();
        formData.append("accion", "mostrarDatos");
        formData.append("tabla", "parametros");
        formData.append("limite", 1);
        
        axios.post(`${this.url}/ajax/ajax.generico.php`, formData)
        .then((res) => {
            this.titulo = res.data.razonsocial
        });
    },
    registrarToken(datos) {
      let losdatos = JSON.parse(datos)
      let usuario = {
        token: losdatos.token,
        idUsuario: losdatos.idUsuario,
        tipoUsuario: losdatos.tipoUsuario,
        ciw: losdatos.ciw,
        emailUsuario: losdatos.emailUsuario
      }
      
      this.updUsuario(usuario)
    },
    cerrarSesion() {
      var formData = new FormData();
      formData.append("accion", "cerrarSesion");
      formData.append("idUsuario", this.idUsuario)
      
      axios.post(`${this.url}/ajax/ajax.usuarios.php`, formData)
      .then(res => {
          if (res.data == 'ok') {
            let usuario = {
              token: '',
              idUsuario: '',
              tipoUsuario: '',
              ciw: '',
              emailUsuario: ''
            }
            
            this.updUsuario(usuario)

            localStorage.clear()
            try {
                this.$router.push(`/inicio`)
            } catch (error) {
                if (!(error instanceof NavigationDuplicated)) {
                    throw error;
                }
            }
          }
      });
    },
    ...mapActions(['cargarLocalStorage', 'updUsuario'])
  },
  computed: {
    url() {
        if ( ["localhost", "127.0.0.1", ""].includes(window.location.hostname) ) {
            return this.urlSandbox
        } else {
            return this.urlProd
        }
    },
    ...mapState(['urlProd', 'urlSandbox', 'token'])
  }
}
</script>

<style scoped>
  .contenido-principal {
      margin-top: 74px;
  }

  /* TRANSITION */
  .fade-enter {
    opacity: 0;
  }

  .fade-enter-active,
  .fade-leave-active {
    opacity: 1;
    transition: opacity 0.2s ease-out;
  }

  .fade-leave-to {
    opacity: 0;
  }
</style>